/**
 * hisTrackApi 车辆轨迹 api
 *
 * @Author  Carey.zhou
 * @DATE    create on 2019/9/18
 * @DESC
 */

import { ajax } from './createApi'
import { truckBaseUrl } from './urlConfig'

/**
 * 轨迹查询
 * @param {vclN, qryBtm, qryEtm}
 */
export function queryHisTrack (params) {
  return ajax({
    method: 'POST',
    url: `${truckBaseUrl}/hisTrack/v2/query`,
    data: params
  })
}

/**
 * 轨迹查询记录
 * @param {pageNo , pageSize}
 */
export function queryHisTrackRecord (params) {
  return ajax({
    method: 'POST',
    url: `${truckBaseUrl}/hisTrack/getHisTrackRecord`,
    data: params
  })
}

/**
 * 获取轨迹回放
 * @param params
 */
export function getHisResult (params) {
  return ajax({
    method: 'GET',
    url: `${truckBaseUrl}/hisTrack/getHisResult/` + params,
    data: ''
  })
}
